module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startTime":"Start Time","endTime":"End Time","PleaseInput":"Please Input {value}","search":"Search","reset":"Reset"},"zh":{"startTime":"开始时间","endTime":"结束时间","PleaseInput":"请输入{value}","search":"搜索","reset":"重置"},"mm":{"startTime":"စတင်သည့်အချိန်","endTime":"ပြီးဆုံးသည့်အချိန်","PleaseInput":"ရိုက်သွင်းပါ {value}","search":"ရှာရန်","reset":"ပြန်လုပ်သည်"}}')
  delete Component.options._Ctor
}
